export const NO_FILTER_SELECTED_TEXT = 'All';
